"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, { forwardRef, createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import { observable, action } from "mobx";
import TextInput, { TextInputSize, TextInputType } from "../TextInput/TextInput";
import { Search, Close } from "../../icons";
import IconButton from "../IconButton/IconButton";
import { ButtonSize } from "../Button/Button";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./SearchInput-css";
let SearchInput = class extends React.Component {
  constructor() {
    super(...arguments);
    this.isClearButtonVisible = false;
    this.searchInputRef = createRef();
    this.handleClearClick = () => {
      var _a, _b, _c;
      (_a = this.searchInputRef.current) == null ? void 0 : _a.focus();
      (_c = (_b = this.props).onClear) == null ? void 0 : _c.call(_b);
    };
    this.handleClearMouseDown = (event) => {
      event.preventDefault();
    };
    this.handleClearEnter = (node) => {
      forceReflow(node);
      this.isClearButtonVisible = true;
    };
    this.handleClearExited = () => {
      this.isClearButtonVisible = false;
    };
    this.renderClearButton = () => {
      const { value, onClear, theme } = this.props;
      if (!onClear)
        return;
      if (!!value || this.isClearButtonVisible) {
        return /* @__PURE__ */ React.createElement(
          Transition,
          {
            appear: true,
            onEnter: this.handleClearEnter,
            onExited: this.handleClearExited,
            in: !!value,
            timeout: AnimationDuration.Medium
          },
          (status) => /* @__PURE__ */ React.createElement(
            IconButton,
            {
              className: classNames(styles.clear({ visible: ["entering", "entered"].includes(status) }), {
                [darkTheme]: theme === "dark",
                [lightTheme]: theme === "light"
              }),
              "aria-label": "Clear search",
              size: ButtonSize.XSmall,
              icon: /* @__PURE__ */ React.createElement(Close, null),
              onClick: this.handleClearClick,
              onMouseDown: this.handleClearMouseDown
            }
          )
        );
      }
    };
    this.mergeRefs = (instance) => {
      if (this.props.innerRef != null) {
        if (typeof this.props.innerRef === "function") {
          this.props.innerRef(instance);
        } else {
          this.props.innerRef.current = instance;
        }
      }
      this.searchInputRef.current = instance;
    };
  }
  render() {
    const _a = this.props, {
      label,
      value,
      placeholder,
      onClick,
      onKeyDown,
      onChange,
      onFocus,
      onBlur,
      theme,
      variant,
      className,
      size,
      id,
      role,
      onClear,
      innerRef,
      endElement,
      startElement
    } = _a, rest = __objRest(_a, [
      "label",
      "value",
      "placeholder",
      "onClick",
      "onKeyDown",
      "onChange",
      "onFocus",
      "onBlur",
      "theme",
      "variant",
      "className",
      "size",
      "id",
      "role",
      "onClear",
      "innerRef",
      "endElement",
      "startElement"
    ]);
    return /* @__PURE__ */ React.createElement("div", { className: classNames(className, styles.container, "search-input") }, /* @__PURE__ */ React.createElement(
      TextInput,
      __spreadValues({
        labelHidden: true,
        label,
        ref: this.mergeRefs,
        size,
        startElement: startElement === void 0 ? /* @__PURE__ */ React.createElement(Search, null) : startElement,
        endElement: endElement === void 0 ? this.renderClearButton() : endElement,
        type: TextInputType.Search,
        onChange,
        value,
        placeholder,
        onClick,
        onFocus,
        onBlur,
        onKeyDown,
        theme,
        variant,
        id,
        role
      }, rest)
    ));
  }
};
SearchInput.defaultProps = {
  size: TextInputSize.Medium,
  value: ""
};
__decorateClass([
  observable.ref
], SearchInput.prototype, "isClearButtonVisible", 2);
__decorateClass([
  action
], SearchInput.prototype, "handleClearEnter", 2);
__decorateClass([
  action
], SearchInput.prototype, "handleClearExited", 2);
SearchInput = __decorateClass([
  observer
], SearchInput);
export default forwardRef(function textInput(props, ref) {
  return /* @__PURE__ */ React.createElement(SearchInput, __spreadValues({ innerRef: ref }, props));
});
